import React from 'react';
import { Heart, Bone, Brain, Baby, Stethoscope, Activity, Dumbbell, Zap, Shield, Thermometer } from 'lucide-react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <Bone size={28} />,
      title: 'Back Pain Treatment',
      desc: 'Comprehensive back pain management including sciatica, herniated disc, spinal stenosis, and chronic lower back pain through manual therapy, exercises, and electrotherapy.',
      keywords: 'back pain physiotherapy, sciatica treatment, spinal physiotherapy Greater Noida',
    },
    {
      icon: <Dumbbell size={28} />,
      title: 'Sports Injury Rehab',
      desc: 'Specialized rehabilitation for ACL tears, meniscus injuries, rotator cuff tears, hamstring strains, and all sports-related injuries to get athletes back in the game.',
      keywords: 'sports injury physiotherapy, ACL rehab, athlete recovery Greater Noida',
    },
    {
      icon: <Brain size={28} />,
      title: 'Stroke Rehabilitation',
      desc: 'Neuro-physiotherapy programs to restore motor function, improve balance, enhance coordination, and maximize independence after stroke or brain injury.',
      keywords: 'stroke physiotherapy, neuro rehab, paralysis treatment Noida',
    },
    {
      icon: <Activity size={28} />,
      title: 'Joint Pain Therapy',
      desc: 'Effective treatment for arthritis, knee pain, shoulder pain, hip pain, and all joint-related conditions using mobilization, ultrasound, and therapeutic exercises.',
      keywords: 'joint pain physiotherapy, arthritis treatment, knee pain relief Greater Noida',
    },
    {
      icon: <Stethoscope size={28} />,
      title: 'Post-Surgery Rehab',
      desc: 'Structured post-operative physiotherapy for knee replacement, hip replacement, spinal surgery, and fracture fixation to ensure complete and speedy recovery.',
      keywords: 'post surgery physiotherapy, knee replacement rehab, fracture recovery',
    },
    {
      icon: <Zap size={28} />,
      title: 'Electrotherapy',
      desc: 'Advanced electrotherapy treatments including TENS, IFT, ultrasound therapy, laser therapy, and shockwave therapy for pain relief and tissue healing.',
      keywords: 'electrotherapy, TENS therapy, ultrasound physiotherapy Greater Noida',
    },
    {
      icon: <Shield size={28} />,
      title: 'Posture Correction',
      desc: 'Assessment and correction of poor posture, scoliosis, kyphosis, and workplace ergonomics to prevent chronic pain and musculoskeletal disorders.',
      keywords: 'posture correction, scoliosis physiotherapy, ergonomic assessment Noida',
    },
    {
      icon: <Thermometer size={28} />,
      title: 'Pediatric Physiotherapy',
      desc: 'Specialized physiotherapy for children with cerebral palsy, developmental delays, muscular dystrophy, and congenital conditions in a child-friendly environment.',
      keywords: 'pediatric physiotherapy, cerebral palsy treatment, child physiotherapist Greater Noida',
    },
  ];

  return (
    <div className="services-page">
      <section className="section">
        <div className="section-header">
          <h1>Our Physiotherapy Services</h1>
          <p>Comprehensive physiotherapy treatments for pain relief and rehabilitation in Greater Noida</p>
        </div>
        <div className="services-grid">
          {services.map((service, i) => (
            <div className="service-card-large" key={i} data-keywords={service.keywords}>
              <div className="service-icon-large">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <span className="service-keywords">{service.keywords}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
